import React from 'react';
import { about } from '../data/profile';
import { education } from '../data/education';
import { languages } from '../data/languages';
import { SectionHeading } from './ui/SectionHeading';
import { Tag } from './ui/Tag';
import { Reveal } from '../lib/motion';

export default function About() {
  return (
    <section id="sobre" style={{ padding: 'var(--section-pad-y) clamp(20px,5vw,56px)', position: 'relative' }}>
      <div style={{ maxWidth: 'var(--container-wide)', margin: '0 auto' }}>
        <Reveal><SectionHeading index="01" eyebrow="Sobre" title="Quem está por trás do código" /></Reveal>
        <div className="about-grid" style={{ display: 'grid', gap: 'clamp(32px,5vw,72px)', marginTop: 56 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            {about.map((p, i) => (
              <Reveal key={i} delay={i * 90}>
                <p style={{ fontSize: i === 0 ? 'var(--text-lg)' : 'var(--text-md)', lineHeight: 1.7, color: i === 0 ? 'var(--text-primary)' : 'var(--text-secondary)', margin: 0 }}>{p}</p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={120}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 20, padding: '28px', borderRadius: 'var(--radius-lg)', background: 'var(--bg-surface)', border: '1px solid var(--border-subtle)' }}>
              <div>
                <span className="t-eyebrow" style={{ display: 'block', marginBottom: 10 }}>Formação</span>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 17 }}>{education.university}</div>
                <div style={{ color: 'var(--text-secondary)', fontSize: 14 }}>{education.degree}</div>
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>{education.period}</div>
              </div>
              <div style={{ height: 1, background: 'var(--border-subtle)' }} />
              <div>
                <span className="t-eyebrow" style={{ display: 'block', marginBottom: 12 }}>Idiomas</span>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {languages.map((l) => (
                    <div key={l.name} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
                      <span style={{ fontWeight: 600, fontSize: 15 }}>{l.name}</span>
                      <Tag variant="outline" size="sm">{l.level}</Tag>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
